import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pre-youtube-modal',
  templateUrl: './pre-youtube-modal.component.html',
  styleUrls: ['./pre-youtube-modal.component.scss'],
})
export class PreYoutubeModalComponent {
  constructor(private dialogRef: MatDialogRef<PreYoutubeModalComponent>) {}

  onOk() {
    this.dialogRef.close(true);
  }
}
